import React from "react";

/**
 * Standardized results header with count display.
 * Export functionality has been moved to the Pagination component.
 */
const ResultsHeader = ({
// Display
  totalCount = 0,
  filteredCount = null,
  entityName = "results",
  // Additional actions
  children,
  className = "",
}) => {
  const hasFilters = filteredCount !== null && filteredCount !== totalCount;

  return (
    <div
 className={`flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-4 ${className}`}
    >
      {/* Results count */}
      <div className="flex items-center gap-2">
     <p className="text-sm text-muted-foreground">
  {hasFilters ? (
            <>
     Showing{" "}
            <span className="font-medium text-foreground">
          {filteredCount.toLocaleString()}
        </span>{" "}
      of{" "}
        <span className="font-medium text-foreground">
         {totalCount.toLocaleString()}
           </span>{" "}
   {entityName}
            </>
          ) : (
            <>
              <span className="font-medium text-foreground">
           {totalCount.toLocaleString()}
            </span>{" "}
       {entityName}
            </>
      )}
        </p>

        {hasFilters && (
       <span className="badge badge-secondary badge-sm">Filtered</span>
  )}
      </div>

      {/* Additional actions passed as children */}
      {children && (
      <div className="flex items-center gap-2">
          {children}
  </div>
      )}
    </div>
  );
};

export default ResultsHeader;
